import { Injectable } from "@angular/core";
import { KartgeometriDTO } from "~app/common/models/karta/KartgeometriDTO";
import { KontraktDTO } from "~app/common/models/virkeskop/VirkeskopKontraktAvtalSaveDTO";
import { KartgeometrierOsparadeDrivningspunkterValidering } from "~app/features/map/popups/kartgeometri-popup/kartgeometri.model";

@Injectable({
    providedIn: "root"
})
export class KontraktDrivningspunkterValidationService {

    constructor() {
        // Tom konstruktor
    }

    allValid = (kontrakt: KontraktDTO) => (this.isKontraktLarmkoordinatValid(kontrakt) && this.isKontraktAvlaggValid(kontrakt) && this.isKontraktKojplatsValid(kontrakt));

    isKontraktKojplatsValid = (kontrakt: KontraktDTO) => {
        if (!kontrakt || !kontrakt.kartgeometrier) {
            return false;
        }
        return this.isKojplatsValid(kontrakt.kartgeometrier);
    };

    isKontraktLarmkoordinatValid = (kontrakt: KontraktDTO) => {
        if (!kontrakt || !kontrakt.kartgeometrier) {
            return false;
        }
        return this.isLarmkoordinatValid(kontrakt.kartgeometrier);
    };

    isKontraktAvlaggValid = (kontrakt: KontraktDTO) => {
        if (!kontrakt || !kontrakt.kartgeometrier) {
            return false;
        }
        return this.isAvlaggValid(kontrakt.kartgeometrier);
    };

    private readonly isKojplatsValid = (kartgeometrier: KartgeometriDTO[]) => kartgeometrier
        .filter(KartgeometrierOsparadeDrivningspunkterValidering.isKojplats)
        .length > 0;

    private readonly isLarmkoordinatValid = (kartgeometrier: KartgeometriDTO[]) => kartgeometrier
        .filter(KartgeometrierOsparadeDrivningspunkterValidering.isLarmpunkt)
        .length === 1;

    private readonly isAvlaggValid = (kartgeometrier: KartgeometriDTO[]) => {
        const avlaggGeometrier = kartgeometrier.filter(KartgeometrierOsparadeDrivningspunkterValidering.isAvlagg);
        return avlaggGeometrier.length > 0 && avlaggGeometrier.every(avlagg => !!avlagg.tillganglighetsklass);
    };

}
